import * as React from 'react';
import { useTranslation } from 'react-i18next';
import UninitializedQuizInfo from './UninitializedQuizInfo';
import SurveyScriptInsert from '../../../__core/Providers/SurveyMonkey/Survey';
import { SurveyStyle } from '../Styles/Materials';

type QuizProps = {
  surveyUrl: string;
};

const Quiz: React.FunctionComponent<QuizProps> = ({ surveyUrl }) => {
  const { t } = useTranslation();

  return surveyUrl ? (
    <SurveyStyle id="material-with-quiz">
      <div className="quiz-info">
        {t(
          'Take this quiz. You can approach the quiz many times. The highest score is included in the score.'
        )}
        &nbsp;&nbsp;
        <b>
          {t('The quiz result may refresh with a delay of several minutes.')}
        </b>
      </div>
      <SurveyScriptInsert urlWithParams={surveyUrl} />
    </SurveyStyle>
  ) : (
    <UninitializedQuizInfo />
  );
};

export default Quiz;
